import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EventMessageType } from '@Types/common/EventMessageType';

interface InitialStateType {
  eventType: EventMessageType;
}

const initialState: InitialStateType = {
  eventType: 'NONE',
};

const eventMessageSlice = createSlice({
  name: 'eventMessage',
  initialState,
  reducers: {
    sendEventType: (
      state,
      action: PayloadAction<InitialStateType['eventType']>
    ) => {
      state.eventType = action.payload;
    },
  },
});

export const { sendEventType } = eventMessageSlice.actions;

const { actions } = eventMessageSlice;

export const eventMessageActions = {
  ...actions,
};

export default eventMessageSlice;
